import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "uefa-team-table" }
const _hoisted_2 = { class: "uefa-team-table__table" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "uefa-team-table__head",
      title: "Helyezés"
    }, " # "),
    /*#__PURE__*/_createElementVNode("th", { class: "uefa-team-table__head uefa-team-table__head--item" }, " Csapat "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "uefa-team-table__head",
      title: "Meccs"
    }, " M "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "uefa-team-table__head",
      title: "Győzelem"
    }, " Gy "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "uefa-team-table__head",
      title: "Döntetlen"
    }, " D "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "uefa-team-table__head",
      title: "Vereség"
    }, " V "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "uefa-team-table__head",
      title: "Lőtt gólok"
    }, " LG "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "uefa-team-table__head",
      title: "Kapott gólok"
    }, " KG "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "uefa-team-table__head",
      title: "Gólkülönbség"
    }, " GK "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "uefa-team-table__head",
      title: "Pontszám"
    }, " P "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "uefa-team-table__head",
      title: "Utolsó öt meccs"
    }, " Utolsó öt ")
  ])
], -1)
const _hoisted_4 = { class: "uefa-team-table__cell" }
const _hoisted_5 = { class: "uefa-team-table__cell uefa-team-table__cell--item" }
const _hoisted_6 = { class: "uefa-team-table__item" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "uefa-team-table__name" }
const _hoisted_9 = { class: "uefa-team-table__description" }
const _hoisted_10 = { class: "uefa-team-table__cell" }
const _hoisted_11 = { class: "uefa-team-table__cell" }
const _hoisted_12 = { class: "uefa-team-table__cell" }
const _hoisted_13 = { class: "uefa-team-table__cell" }
const _hoisted_14 = { class: "uefa-team-table__cell" }
const _hoisted_15 = { class: "uefa-team-table__cell" }
const _hoisted_16 = { class: "uefa-team-table__cell" }
const _hoisted_17 = { class: "uefa-team-table__cell" }
const _hoisted_18 = { class: "uefa-team-table__cell" }
const _hoisted_19 = { class: "uefa-team-table__results" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (content, i) => {
          return (_openBlock(), _createElementBlock("tr", null, [
            _createElementVNode("td", _hoisted_4, _toDisplayString(i + 1), 1),
            _createElementVNode("td", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: content.logo,
                  width: "48",
                  height: "48",
                  loading: "lazy"
                }, null, 8, _hoisted_7),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("strong", null, _toDisplayString(content.name), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(content.country), 1)
                ])
              ])
            ]),
            _createElementVNode("td", _hoisted_10, _toDisplayString(content.matchesPlayed), 1),
            _createElementVNode("td", _hoisted_11, _toDisplayString(content.matchesWon), 1),
            _createElementVNode("td", _hoisted_12, _toDisplayString(content.matchesDrawn), 1),
            _createElementVNode("td", _hoisted_13, _toDisplayString(content.matchesLost), 1),
            _createElementVNode("td", _hoisted_14, _toDisplayString(content.goalsFor), 1),
            _createElementVNode("td", _hoisted_15, _toDisplayString(content.goalsAgainst), 1),
            _createElementVNode("td", _hoisted_16, _toDisplayString(content.goalDifference), 1),
            _createElementVNode("td", _hoisted_17, _toDisplayString(content.points), 1),
            _createElementVNode("td", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.results, (result) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["uefa-team-table__result-item", `uefa-team-table__result-item--${result}`])
                  }, null, 2))
                }), 256))
              ])
            ])
          ]))
        }), 256))
      ])
    ])
  ]))
}